/**
 * P2-04: CollapsiblePanel —— 通用折叠面板（左栏各区块复用）。
 *
 * 逐结构对齐旧 WCollapsiblePanel（js/jsx/left.jsx.js:16-48）：
 * - 折叠态为组件内部 state，**不持久化**（重挂载即回到展开，与旧版一致，
 *   见 webui/src/panels/left/INVENTORY.md "折叠/编辑状态存哪"）；
 * - 折叠链接保留旧 class 钩子 `link collapse` 与原生 `title=props.title`；
 * - 折叠时显示 ">(title)" 文本，展开时显示 `.svg-icon.down` 图标
 *   （图标本身由旧 CSS 提供，本组件只输出结构）；
 * - 旧版 href="#!" 且不 preventDefault，此处保持一致。
 *
 * 注意：旧 WResourceTable/WCraftTable 各自实现折叠、**并未使用** WCollapsiblePanel
 * （left.jsx.js:568-573, 681-686）；旧版仅 WPins 使用本组件（left.jsx.js:830）。
 */
import { useState, type ReactNode } from "react";

export interface CollapsiblePanelProps {
  /** 面板标题：折叠时显示为 ">(title)"，同时作为折叠链接的原生 title */
  title: string;
  children?: ReactNode;
}

export function CollapsiblePanel({ title, children }: CollapsiblePanelProps) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div>
      <div>
        <div className="left">
          <a
            href="#!"
            className="link collapse"
            tabIndex={1}
            title={title}
            onClick={() => {
              // 旧版不 preventDefault（href="#!" 会写入 location.hash），保持一致
              setIsCollapsed(!isCollapsed);
            }}
          >
            {isCollapsed ? ">(" + title + ")" : <div className="svg-icon down" />}
          </a>
        </div>
      </div>
      {!isCollapsed && children}
    </div>
  );
}
